import { Story } from '../../DocTypes';

export const selectableStory: Story = {
  title: 'Selectable',
  description: 'List with selectable items',
  coreComponent: {
    html: `<tag-list primary-field='name' selectable></tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Harry Maguire' },
      { name: 'Luke Shaw' },
      { name: 'Mason Mount' },
      { name: 'Dele Alli' },
    ]);
  });
    `,
  },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    selectable
    data={[
      { name: 'Harry Maguire' },
      { name: 'Luke Shaw' },
      { name: 'Mason Mount' },
      { name: 'Dele Alli' },
    ]}
  />`,
  },
};
